import { useEffect, useContext, useState, FunctionComponent } from 'react';
import SitecoreLink from 'Foundation/GlassMapper/SitecoreLink';
import '../Slider/Cards/FavoritesPanel.scss';
import { ISliderContext } from '../Slider/Models/Panels';
import { SliderContext } from '../Slider/SliderContext';
import { findFavorites } from 'Feature/Favorites/FavoritesHelper';
import { CircularProgressSpinner } from '@lmig/sales-ui-circular-progress-spinner';

interface IFavoritesList {
  sections: IReactNavSection[];
}

const FavoritesList: FunctionComponent<IFavoritesList> = (props: IFavoritesList) => {
  const limit: number = 8;
  const sliderContext = useContext<ISliderContext>(SliderContext);
  const [favorites, setFavorites] = useState<INavigationLink[]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    function SetUpFavorites() {
      let newFavorites: INavigationLink[] | undefined =
        sliderContext.favorites && props.sections.length > 0
          ? findFavorites(sliderContext.favorites, props.sections)
          : undefined;
      if (newFavorites) {
        setFavorites(newFavorites.slice(0, limit));
        setIsLoading(false);
      }
    }

    SetUpFavorites();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sliderContext.favorites, props.sections]);

  return (
    <div className="navigation-section favorites-section">
      <div className="menu-section-links">
        {favorites && favorites.length > 0 ? (
          favorites.map((link: INavigationLink) => (
            <div className="menu-section-link">
              <SitecoreLink
                Class={link.Link.Class}
                Goal={link.Link.Goal}
                key={link.Link.Text}
                Target={link.Link.Target}
                Text={link.Link.Text}
                Url={link.Link.Url}
                TargetId={link.Link.TargetId}
                Favoritable={true}
                CaretPosition={'none'}
                IsKeyContactLink={link.Link.IsKeyContactLink}
                OnClick={link.OnClick} // the only reason a favorited item would need an onclick was for key contacts loading the sub panel
                SubText={link.Link.SubText}
              />
            </div>
          ))
        ) : favorites && favorites.length == 0 && !isLoading ? (
          <div className="navigation-section">
            <div className="no-favorites">Your favorites will appear here.</div>
          </div>
        ) : (
          <CircularProgressSpinner size="32" aria-label="Getting favorites..." className="centered-loading-spinner" />
        )}
      </div>
    </div>
  );
};

export default FavoritesList;
